import { graphql } from 'client/gql';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { ClassbookView } from 'components/Classbook/components/ClassbookView/ClassbookView';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useQuery } from 'urql';

const ClassbookCoursesSubpagePageQueryDocument = graphql(`
  query ClassbookCoursesSubpagePageData($profile: ID!) {
    ...PermissionCheckerFields
  }
`);

export const ClassbookCoursesSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const profileUuid = pimAuthClaims.getProfile().uuid;

  const [{ data }] = useQuery({
    query: ClassbookCoursesSubpagePageQueryDocument,
    variables: {
      profile: profileUuid,
    },
  });

  const permissions = usePermissionChecker(data);
  const organization = useAuthClaims().pimAuthClaims.getOrganization();

  return (
    <BpSubpage isForbidden={!permissions?.canViewClassbookCoursesAndClasses(organization)}>
      <ClassbookView />
    </BpSubpage>
  );
};
